module.exports = __webpack_public_path__ + "img/user_collection_null_logo_MyMind.4eaece69.svg";